import FormValidationStrategy from "../strategy/FormValidationStrategy.js";

export default class ConfirmPasswordValidationStrategy extends FormValidationStrategy {
  validate(valueString, isRequired, form) {
    const confirmPasswordValue = valueString.toString().trim();

    const passwordField =
      form && form.querySelector('[data-validation-handler="password"]');
    const passwordValue = passwordField ? passwordField.value.trim() : "";

    let isValid = false;

    if (isRequired && !confirmPasswordValue.length) {
      return {
        isValid,
        message: this.loadErrorMessage("empty", "Подтверждение пароля"),
      };
    }

    if (confirmPasswordValue !== passwordValue) {
      return {
        isValid,
        message: "Пароли не совпадают",
      };
    }

    isValid = true;
    return {
      isValid,
      message: "",
    };
  }
}
